import React from 'react';
import { StyledCTAButton, StyledCTAButtonLink } from './styles';

const CTAButton = ({ ctaText, onCtaClickHandler, bookOnlineUrl }) => {
  if (bookOnlineUrl) {
    return (
      <StyledCTAButtonLink
        mode="primary"
        href={bookOnlineUrl}
        data-testid="MapCardCTA"
      >
        {ctaText}
      </StyledCTAButtonLink>
    );
  }

  return (
    <StyledCTAButton
      type="button"
      mode="primary"
      onClick={onCtaClickHandler}
      data-testid="MapCardCTA"
    >
      {ctaText}
    </StyledCTAButton>
  );
};

export default CTAButton;
